import React from 'react';
import { useAuth } from '../../context/AuthContext';

// Small profile card shown after login in header/sidebar area
export default function PatientProfileCard({ compact = false }) {
  const { user } = useAuth();
  if (!user) return null;

  const initials = (user.name || 'P')
    .split(' ')
    .map(w => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const genderIcon = user.gender === 'Male'
    ? 'fa-mars text-blue-500'
    : user.gender === 'Female'
    ? 'fa-venus text-pink-500'
    : 'fa-genderless text-text-muted';

  if (compact) {
    // Small inline version for header
    return (
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
          <span className="text-white text-xs font-bold">{initials}</span>
        </div>
        <div className="min-w-0">
          <p className="text-xs font-semibold text-text-primary truncate">{user.name || 'Patient'}</p>
          <p className="text-[10px] text-text-muted">+91 {user.phone}</p>
        </div>
      </div>
    );
  }

  // Full card version for sidebar/profile page
  return (
    <div className="bg-gradient-to-r from-primary to-teal-600 rounded-2xl p-4 text-white mb-4 mx-4">
      <div className="flex items-center gap-3">
        {/* Avatar with initials */}
        <div className="w-14 h-14 rounded-full bg-white/20 border-2 border-white/40
                        flex items-center justify-center flex-shrink-0 shadow-sm">
          <span className="text-white text-xl font-black">{initials}</span>
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <p className="font-bold text-base leading-tight truncate">
            {user.name || 'Patient'}
          </p>
          <p className="text-white/80 text-xs mt-0.5">
            <i className="fa-solid fa-phone text-[10px] mr-1" />+91 {user.phone}
          </p>
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            {user.age && (
              <span className="bg-white/20 text-white text-[10px] px-2 py-0.5 rounded-full">
                {user.age} yrs
              </span>
            )}
            {user.gender && (
              <span className="bg-white/20 text-white text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1">
                <i className={`fa-solid ${genderIcon} text-[9px]`} />
                {user.gender}
              </span>
            )}
            {user.location?.city && (
              <span className="bg-white/20 text-white text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1">
                <i className="fa-solid fa-location-dot text-[9px]" />
                {user.location.city}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
